import { ImageSize } from '@app/models/enums'
import { IProperty } from '@app/models/Property'
import * as React from 'react'
import Image from './Image'

export interface IPropertyThumbnailImageProps {
  property: string | IProperty
  size: number
}

export default class PropertyThumbnailImage extends React.PureComponent<
  IPropertyThumbnailImageProps
> {
  public render() {
    const imageStyle: React.CSSProperties = {
      borderRadius: '5px',
    }

    if (typeof this.props.property === 'string') {
      return (
        <img
          height={this.props.size}
          src={`/api/Properties/${
            this.props.property
          }/ThumbnailImage${this._getSizeQuery(this.props.size)}`}
          style={imageStyle}
          width={this.props.size}
        />
      )
    } else {
      const property = this.props.property as IProperty
      return (
        <Image
          defaultImageUrl={`/images/default-property${this._getDefaultImageSize(
            this.props.size,
          )}.png`}
          height={this.props.size}
          image={property.thumbnailImage}
          size={this._getImageSize(this.props.size)}
          style={imageStyle}
          width={this.props.size}
        />
      )
    }
  }

  private _getDefaultImageSize(size: number): string {
    return this._getSizeQuery(size).replace(/[\?=&]/g, '_')
  }

  private _getImageSize(size: number): ImageSize {
    if (size <= 50) {
      return ImageSize.h50w50
    } else if (size <= 250) {
      return ImageSize.h100w100
    } else {
      return ImageSize.h500w500
    }
  }

  private _getSizeQuery(size: number): string {
    if (size <= 50) {
      return '?h=50&w=50'
    } else if (size <= 250) {
      return '?h=100&w=100'
    } else {
      return '?h=500&w=500'
    }
  }
}
